export default __webpack_public_path__ + "static/media/Autumn_season.608e4f95.png";